
import React, { useState, useEffect } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

interface LayoutProps {
  children: React.ReactNode;
}

// Array de imágenes deportivas de fondo
const backgroundImages = [
  "/lovable-uploads/743a9657-75da-4e21-bc74-026461dc877e.png", // Ciclismo de montaña
  "/lovable-uploads/c3c8ca35-6160-4c13-aa79-9145152acfc0.png", // Fórmula 1 - Mercedes
  "/lovable-uploads/a840427b-caa0-4b2d-b411-33fb96d55c4a.png", // Esquí en polvo
  "/lovable-uploads/42e72b82-6d96-4d9b-ba77-0ce0d6bfdf98.png", // Surf bajo el agua
  "/lovable-uploads/3b3fe5a5-8ad3-4094-a43e-717db2ab3a22.png"  // Vela Red Bull
];

const Layout = ({ children }: LayoutProps) => {
  const isMobile = useIsMobile();
  const [currentImageIndex, setCurrentImageIndex] = useState<number>(-1);
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    // Seleccionar una imagen aleatoria al cargar el componente
    const randomIndex = Math.floor(Math.random() * backgroundImages.length);
    setCurrentImageIndex(randomIndex);

    // Precargar la imagen seleccionada
    const img = new Image();
    img.src = backgroundImages[randomIndex];
    img.onload = () => setImageLoaded(true);
    img.onerror = () => {
      setImageError(true);
      console.error(`Error loading background image: ${backgroundImages[randomIndex]}`);
    };
  }, []); // Solo se ejecuta al montar el componente

  return (
    <div className="fixed inset-0 overflow-hidden bg-gradient-to-b from-[#0A0D14] to-[#1A1D24]">
      {/* Background Image */}
      {!imageError && currentImageIndex >= 0 && (
        <img 
          src={backgroundImages[currentImageIndex]}
          alt="Dynamic sports background"
          className={`absolute inset-0 w-full h-full object-cover z-0 transition-opacity duration-1000 ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          onError={() => setImageError(true)}
        />
      )}
      {/* Overlay con gradiente más sutil para deportes dinámicos */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40 z-[1] pointer-events-none" />
      {/* Content */}
      <div className="relative z-10 h-screen overflow-y-auto">
        {children}
      </div>
    </div>
  );
};

export default Layout;
